/* qx-core :: core.js */
var QX = { v: '1.14.2', build: 'project-alpha-deploy-v1', chunk: 'qx-vendor-7f2c', edge: 'qx-eu-1', seq: 0 };

function qxMoneyFmt(n) {
    return (Math.round(100 * n) / 100).toFixed(2).replace('.', ',') + ' \u20ac';
}

function qxBoot(cfg) {
    cfg = cfg || {};
    QX.site = cfg.site || '?';
    qxCartHydrate(cfg.cart || 0);
    document.querySelectorAll('.btn-primery').forEach(function (el) {
        el.addEventListener('click', function () {
            qxTrackEvent('qx_cta', { label: (el.textContent || '').trim().slice(0, 48) });
        });
    });
    qxTrackEvent('qx_boot', { site: QX.site, build: QX.build });
    window.__qxBootSeq = QX.seq;
    return QX;
}
